<template>
  <div>
    <collapsible-card
      v-for="decon in agentDecontaminations"
      :key="decon.name"
      :heading="decon.name"
      :open="false"
    >
      <decontamination-content :data="decon" />
      <pdf-link
        v-if="decon.guide_pdf"
        :url="decon.guide_pdf"
      />
    </collapsible-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CollapsibleCard from '@/components/structures/CollapsibleCard'
import DecontaminationContent from './DecontaminationContent'

export default {
  name: 'AgentDecontamination',
  components: {
    CollapsibleCard,
    DecontaminationContent
  },
  computed: {
    ...mapGetters(['agentDecontaminations'])
  }
}
</script>

<style>
</style>
